export const faq_en = [
    {
        name: 'Coverage',
        items: [
            {
                question: 'Am I prioritised on the tower?',
                answer: "The MTN Fixed LTE coverage map is generated specifically based on capacity and network availability, so although you'll be sharing the network with mobile LTE subscribers within the Fixed LTE coverage area, you won't be impacted by congestion issues."
            }
        ]
    },
    {
        name: 'Data',
        items: [
            {
                question: 'AFRIHOST- Does unused data roll over at the end of the month?',
                answer: "In-bundle Anytime data will roll over for up to 60 days within a Calendar Month. Unused Night Time data and Bonus Data does not roll over."
            },
            {
                question: 'Does Fly.cool LTE data roll over?',
                answer: "Anytime and Night Time data will roll over for 30 days should you not have used all your available data. This data will be used first before the new month data gets used."
            },
            {
                question: 'How do I view my data usage?',
                answer: "You can easily check your data usage at any time via your customer portal."
            },
            {
                question: 'What is the difference between Anytime data and Night Time data?',
                answer: "Anytime data can be used anytime of the day. Night time data is valid from 12Am to 6AM."
            },
            {
                question: 'What time is Night Time Data?',
                answer: "The Night Time Data period is between 12:00AM and 6AM."
            },
        ]
    },
    {
        name: 'Data Top-up',
        items: [
            {
                question: 'Can I top-up?',
                answer: "Yes, top-ups are available in the customer portal."
            },
            {
                question: 'How do I top up my data?',
                answer: "1. Log into your customer portal. 2. Select the Connectivity section. 3. Select the Top up option. 4. Select the pay option and finalise the transaction."
            },
            {
                question: 'Will the top up data expire?',
                answer: "Data Bundle Topups are valid for 30 days from purchase. For example, if you purchase a Topup package on the 15th of the month, the package will expire on the 14th of the next month at 23:59. Any unused Topup data will be forfeited at 23:59 on the expiry date."
            },
        ]
    },
    {
        name: 'Hardware',
        items: [
            {
                question: 'Can I use my LTE SIM Card in other routers?',
                answer: "The MTN LTE SIM card will only work on the approved devices. If you insert your SIM card into a device that has not been approved by MTN, the SIM card will be blocked, and you will lose your internet access. You will then need to contact our Support team to get the SIM card unblocked."
            },
            {
                question: 'Can I use my own device with my SIM Card?',
                answer: "Only approved CAT6 devices will work with the SIM Only packages on the MTN LTE-A Network. If you are using a new LTE SIM card with your own device, please visit see our Set Up Guide for instructions on how to get connected."
            },
            {
                question: 'Can I use the SIM Card in another device such as a cell phone?',
                answer: "The MTN LTE SIM card will only work on the approved router devices. If you insert your SIM card into Cell Phone or Tablet, the SIM card will be blocked, and you will lose your internet access. You will then need to contact our Support team to get the SIM card unblocked."
            },
            {
                question: 'How many wireless devices can I connect to my Wi-Fi router?',
                answer: "You can connect up to 64 wireless devices on the routers supplied by Fly.cool."
            },
        ]
    },
    {
        name: 'New Account',
        items: [
            {
                question: 'Do I need to RICA my SIM card?',
                answer: "Yes. You will need to have your original barcoded Identity Document, as well as a valid proof of residence. You will also be required to have a copy of your ID and proof of residence available when your SIM is delivered, and you (the account holder) must sign for it in person."
            },
            {
                question: 'Do I need to sign up for a contract?',
                answer: "Our MTN Fixed LTE services are offered on a month-to-month basis."
            },
            {
                question: 'How long does it take to activate after delivery?',
                answer: "Your SIM card should be active within 30 minutes after delivery. In extreme cases it can take up to 72 hours, but this is highly unlikely. Should you have trouble connecting after 30 minutes, please reboot your device and try to connect again."
            },
            {
                question: 'What happens if I sign up in the middle of the month?',
                answer: "All Fixed LTE packages are charged pro-rata. So, if you sign up halfway through the month you will pay half the monthly fee and receive half the data for the rest of the month."
            },
            {
                question: 'What warranty does my LTE device have?',
                answer: ""
            },
        ]
    },
    {
        name: 'Product',
        items: [
            {
                question: 'Can I have multiple MTN Fixed LTE services?',
                answer: "Yes, as long as they're used at the addresses where the application for each is placed."
            },
            {
                question: 'Can I upgrade or downgrade my service?',
                answer: "All our fixed LTE packages can be upgraded or downgraded via your customer portal. As your package is prepaid, we will only the change on the 1st of the following month, regardless of when in the month the request is made or whether it is an upgrade or downgrade."
            },
            {
                question: 'Can I use this service on the go or only at certain locations?',
                answer: "The MTN Fixed LTE service is designed to be used at your home or office, and MTN will lock the service to the address for where you place an order to use the service. If you have tried to use the services at a different address and the services are blocked, you will need to contact our support services of log a issue on your customer portal to request assistance to resolve the problem."
            },
            {
                question: 'Is there a cancellation policy?',
                answer: "You can cancel your data package in two ways. 1) Simply do not renew your next months data package. 2) Cancel the account permanently in cases of moving to a area where you have no coverage or you have sold the device to another person (SIM card cannot be sold due to RICA requirements) and you want to remove the serial numbers from your account. In this case, go to the customer portal and raise a issue to cancel your account."
            },
            {
                question: 'What happens if I move to a new house?',
                answer: "You can request to have your Fixed LTE service moved to another location once a year."
            },
            {
                question: 'What happens to my LTE device and MTN SIM when I move address?',
                answer: "If you move to another location, you will need to contact our Support team or go to your customer portal to request and address change in order to assign the SIM card to the new location as the service is locked to a single tower in the area."
            },
            {
                question: 'What if I move and my new area has no coverage?',
                answer: "Our MTN Fixed LTE services can only be used in areas with coverage. If you're moving to an area without coverage, our cancellations process is quite simple and easy."
            },
            {
                question: 'Why do I need to provide my address where the device will be used?',
                answer: "It is important to give us the correct address where the product will be used, as the SIM card will be locked to the location they specified during sign up. According to RICA, your physical address must be recorded and be verified by the necessary documents."
            },
        ]
    },
];